module.exports = __webpack_public_path__ + "static/media/tab_pin_icon_inactive.546e9736.svg";